exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3d0b1749","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/sass-resources-loader/lib/loader.js?{"resources":["/usr/src/app/src/assets/_include-media.scss","/usr/src/app/src/assets/palette.scss"]}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/profile.vue
// module id = HIWr
// module chunks = 1